export default {"src":"/_next/static/media/youtube-icon.64951c74.svg","height":32,"width":32};